import { Link } from 'react-router-dom';
import './SetupAgentPage.css';
import './ViewAgentPage.css';

const ReportsPage = () => {
  const userString = localStorage.getItem('user');
  const user = userString ? JSON.parse(userString) : {};
  const role = user.role || 'STANDARD';
  const isAdmin = role === 'ADMIN';

  const adminReports = [
     {
      id: 1,
      title: 'Agent Activity Report',
      description: 'Create an Agent Performance Report',
      icon: '\uD83D\uDCC8',
      path: '/agent-activity-report',
      color: '#4caf50'
    },
    {
      id: 2,
      title: 'Queue Performance Report',
      description: 'Create a Queue Performance Report',
      icon: '\uD83D\uDCC9',
      path: '/queue-performance-report',
      color: '#2196f3'
    },
    {
        id: 3,
        title: 'Configuration Gap Report',
        description: 'Create a Configuration Gap Report',
        icon: '\uD83D\uDCCA',
        path: '/configuration-gap-report',
        color: '#ff5722',
        comingSoon: true
    },
    {
        id: 4,
        title: 'Hold Time Analysis',
        description: 'Create a Hold Time Analysis Report',
        icon: '\uD83D\uDCCA',
        path: '/holdtime-analysis-report',
        color: '#ff9800',
        comingSoon: true
    },
    {
        id: 5,
        title: 'Contact / Customer Journey',
        description: 'Create a Contact / Customer Journey Report',
        icon: '\uD83D\uDCCB',
        path: '/contact-customer-journey-report',
        color: '#9c27b0',
        comingSoon: true
    }
  ]

  const standardReports = [
     {
      id: 1,
      title: 'Agent Activity Report',
      description: 'Create an Agent Performance Report',
      icon: '\uD83D\uDCC8',
      path: '/agent-activity-report',
      color: '#4caf50'
    },
    {
      id: 2,
      title: 'Queue Performance Report',
      description: 'Create a Queue Performance Report',
      icon: '\uD83D\uDCC9',
      path: '/queue-performance-report',
      color: '#2196f3'
    }
  ];
  
  const features = isAdmin ? adminReports : standardReports;

  return (
    <div className="setup-page">
      <div className="page-header">
        <div>
           <h1>Reports</h1>
           <p className="home-subtitle">
            {isAdmin
              ? 'You have administrator access to view agent activity and configurations'
              : 'You have standard access to view agent activity and configurations'}
           </p>
        </div>
        <Link to="/business-admin" className="btn btn-secondary">
          ← Back to Business Administration 
        </Link>
      </div>
     

      <div className="features-grid">
        {features.map((feature) => {
        if (feature.comingSoon) {
            return (
            <div
                key={feature.id}
                className="feature-card feature-card-disabled"
                style={{ '--feature-color': feature.color }}
            >
                <div className="feature-icon">{feature.icon}</div>
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
                <span className="coming-soon-badge">Coming Soon</span>
            </div>
            );
        }
        return (
            <Link
            key={feature.id}
            to={feature.path}
            className="feature-card"
            style={{ '--feature-color': feature.color }}
            >
            <div className="feature-icon">{feature.icon}</div>
            <h3 className="feature-title">{feature.title}</h3>
            <p className="feature-description">{feature.description}</p>
            <span className="feature-arrow">&rarr;</span>
            </Link>
        );
        })}
      </div>
    </div>           
  );
};

export default ReportsPage;